import { ref, watchEffect } from "vue";
import getDate from "@/pages/CreateConnection/utils/dateUtils";

export function useYandexStatistics() {
    const selectedYandexAccount = ref(null)
    const isYandexDataInputRight = ref(false)

    const yandexUpload = ref({
        startDate: {
            type: "exact",
            date: null
        },
        endDate: {
            type: "exact",
            date: null
        }
    })

    function setYandexUpload(data) {
        yandexUpload.value = {
            startDate: data.startDate || { type: "exact", date: null },
            endDate: data.endDate || { type: "exact", date: null }
        }
    }

    function setYandexAccount(account) {
        selectedYandexAccount.value = account
    }

    watchEffect(() => {
        if (selectedYandexAccount.value === null) {
            isYandexDataInputRight.value = false
            return
        }
        if (yandexUpload.value.startDate === null || yandexUpload.value.endDate == null) {
            isYandexDataInputRight.value = false
            return
        }

        const start = getDate(yandexUpload.value.startDate)
        const end = getDate(yandexUpload.value.endDate)

        console.log("UPDATED DATE", start, end)

        if (start === null || end === null) {
            isYandexDataInputRight.value = false
            return
        }
        if (end < start) {
            isYandexDataInputRight.value = false
            return
        }

        isYandexDataInputRight.value = true;
    })

    return {
        selectedYandexAccount,
        yandexUpload,
        isYandexDataInputRight,
        setYandexUpload,
        setYandexAccount,
    }
}